import { render, staticRenderFns } from "./appWhoAreWe.vue?vue&type=template&id=8399c0c4&scoped=true"
import script from "./appWhoAreWe.vue?vue&type=script&lang=js"
export * from "./appWhoAreWe.vue?vue&type=script&lang=js"
import style0 from "./appWhoAreWe.vue?vue&type=style&index=0&id=8399c0c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8399c0c4",
  null
  
)

export default component.exports